import { render, staticRenderFns } from "./FleetHome.vue?vue&type=template&id=8772e162"
import script from "./FleetHome.vue?vue&type=script&lang=js"
export * from "./FleetHome.vue?vue&type=script&lang=js"
import style0 from "./FleetHome.vue?vue&type=style&index=0&id=8772e162&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8772e162')) {
      api.createRecord('8772e162', component.options)
    } else {
      api.reload('8772e162', component.options)
    }
    module.hot.accept("./FleetHome.vue?vue&type=template&id=8772e162", function () {
      api.rerender('8772e162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/views/FleetHome.vue"
export default component.exports